import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { CURRENCY_US, BNPL_SYF } from 'yoda-checkout-components/lib/common/Constants';
import { GC_BALANCE } from 'yoda-checkout-components/lib/common/LabelConstants';
import Image from 'yoda-core-components/lib/components/Image/Image';
import { imagePath } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import currencyFormatter from 'currency-formatter';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { mapCards } from '../../../../../../helpers/Utils/Utils';
import * as styles from './PaymentItem.css';
import paymentService from '../../../../../../services/PaymentService';

const cx = classNames.bind(styles);

export default function PaymentItem({ paymentList, context, isPriceAccurate }) {
    return (
        <div className={dt(['mb-2'])} data-automation-id="at-review-payment-info-container">
            {paymentList
                ? paymentList.map((item) => {
                      const currency = item.currency ? item.currency : CURRENCY_US;
                      const paymentItem = (
                          <div
                              className={`${cx('paymentItemWrapper')} ${dt(['p-0', 'text-small'])}`}
                              data-automation-id={`at-review-paymentItem-wrapper-${mapCards(
                                  item.type
                              )}`}
                          >
                              <div
                                  className={`${cx('cardWrapper')} ${dt([
                                      'mt-0',
                                      'sm:text-medium',
                                      'lg:text-small',
                                      'flex',
                                      'justify-between',
                                      'items-center',
                                  ])}`}
                              >
                                  <div className={dt(['flex', 'items-center'])}>
                                      <span className={cx('imageBlock')}>
                                          <Image
                                              src={imagePath(
                                                  context,
                                                  mapCards(item.type?.replace?.(/\s/g, ''))
                                              )}
                                              alt="icon"
                                              imageRatio={0}
                                              automationId="at-review-payment-icon"
                                              imgClass={dt(['w-10'])}
                                          />
                                      </span>
                                      <span
                                          className={dt([
                                              'ml-3',
                                              'mr-2',
                                              'sm:text-medium',
                                              'lg:text-small',
                                          ])}
                                          data-automation-id="at-review-payment-card-type"
                                      >
                                          {paymentService.getFormattedCardName(item.type)}
                                      </span>
                                      {item.type !== 'PAYPAL' && item.type !== BNPL_SYF && (
                                          <span
                                              className={`${cx(
                                                  'mr-1',
                                                  item.type === 'VISA' ? 'visaLastFourNumber' : ''
                                              )} ${dt(['sm:text-medium', 'lg:text-small'])}`}
                                              data-automation-id="at-review-payment-lastfour"
                                              data-qm-block="true"
                                              data-tlprivate
                                          >
                                              {item.lastFour?.match?.(/\d+/)?.[0]}
                                          </span>
                                      )}
                                  </div>
                                  <span
                                      className={`${cx('paymentAmount')} ${dt([
                                          'ml-2',
                                          'text-left',
                                          'text-black',
                                          'sm:text-medium',
                                          'lg:text-small',
                                          'font-bold',
                                      ])}`}
                                      data-automation-id="at-review-payment-amount"
                                  >
                                      {isPriceAccurate
                                          ? currencyFormatter.format(item.amount, {
                                                code: currency,
                                            })
                                          : 'TBD'}
                                  </span>
                              </div>
                              {item.balance ? (
                                  <div
                                      data-automation-id="at-review-payment-gc-balance"
                                      className={dt(['mt-2', 'text-xsmall', 'text-gray-40'])}
                                  >
                                      <span data-automation-id="at-review-payment-gc-balance-amt">
                                          {currencyFormatter.format(item.balance, {
                                              code: currency,
                                          })}
                                      </span>
                                      <span data-automation-id="at-review-payment-gc-balance-lbl">
                                          {' '}
                                          {GC_BALANCE}
                                      </span>
                                  </div>
                              ) : (
                                  ''
                              )}
                          </div>
                      );
                      return paymentItem;
                  })
                : ''}
        </div>
    );
}

PaymentItem.propTypes = {
    paymentList: PropTypes.arrayOf(PropTypes.object),
    context: PropTypes.objectOf(PropTypes.object).isRequired,
    isPriceAccurate: PropTypes.bool,
};

PaymentItem.defaultProps = {
    paymentList: [],
    isPriceAccurate: false,
};
